import { DELETE_WS, DELETE_WS_SUCCESS, DELETE_WS_ERROR} from './actionTypes';

const initialState = {
    errorDeleteWs: "",
    loadingDeleteWs: false,
    ws: null,
    successDeleteWs: ""
}

const deleteWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_WS:
            state = {
                ...state,
                loadingDeleteWs: true
            }
            break;
        case DELETE_WS_SUCCESS:
            state = {
                ...state,
                loadingDeleteWs: false,
                ws: action.payload.ws, 
                successDeleteWs: action.payload.message
            }
            break;
        case DELETE_WS_ERROR:
            state = { ...state, errorDeleteWs: action.payload, loadingDeleteWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default deleteWorkstations;